// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".custom-reason-select-style .multiselect__tags{\n  height: initial;\n  padding-top:0px;\n}\n\n", ""]);
// Exports
module.exports = exports;
